// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"40583ebf","395":"8e99de92","481":"3e0eda1c","579":"f3d98b73","625":"677d8694","676":"afadd38b","885":"1a00227f","929":"677d8694"}[chunkId] + ".chunk.css";
};